export const LOCAL_STORAGE_KEY = 'mage-cache-storage';
export const MAX_PROJECTS = 5;
